module.exports = __webpack_public_path__ + "static/media/icon-aluguel-tendencia.e72865fe.webp";